import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { laceParts1, laceParts2, laceParts3, laceParts4, laceParts5 } from './parts/laceParts'

export const vWebWithLace = (ctx: CanvasRenderingContext2D, webColor: string, web2Color: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ_縦
  verticalPartOfVWeb2(ctx, web2Color, stitchColor)
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 左半分レース
  laceParts2(ctx, laceColor, 34, 60) // 上1
  laceParts2(ctx, laceColor, 42, 80) // 上2
  laceParts2(ctx, laceColor, 50, 100) // 上3
  laceParts1(ctx, laceColor, 45, 75) // 上2
  laceParts1(ctx, laceColor, 32, 50) // 上1

  // 右半分レース
  laceParts3(ctx, laceColor, 30, 46) // 上1
  laceParts3(ctx, laceColor, 38, 70) // 上2
  laceParts3(ctx, laceColor, 46, 87) // 上3
  laceParts4(ctx, laceColor, 21, 57) // 上1
  laceParts4(ctx, laceColor, 29, 80) // 上2
  laceParts4(ctx, laceColor, 37, 100) // 上3
  laceParts5(ctx, laceColor, 21, 58) // 上1
  laceParts5(ctx, laceColor, 29, 83) // 上2
  laceParts5(ctx, laceColor, 37, 111) // 上3

  crossLace(ctx, laceColor, -7, -20)
  crossLace(ctx, laceColor, 0, 0)

  // ウェブ_横
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)
}

const verticalPartOfVWeb2 = (ctx: CanvasRenderingContext2D, webColor: string, stitchColor: string) => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ_縦
  ctx.beginPath()
  ctx.moveTo(244, 225) // 左＿上
  ctx.quadraticCurveTo(291, 289, 317, 352) // 左＿下
  ctx.quadraticCurveTo(333, 324, 333, 324) // 右＿下
  ctx.quadraticCurveTo(311, 254, 270, 184) // 右＿上
  ctx.quadraticCurveTo(235, 234, 244, 225) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.beginPath()
  ctx.moveTo(296, 153) // 左＿上
  ctx.quadraticCurveTo(311, 254, 333, 325) // 左＿下
  ctx.quadraticCurveTo(353, 288, 353, 288) // 右＿下
  ctx.quadraticCurveTo(339, 233, 330, 122) // 右＿上
  ctx.quadraticCurveTo(319, 124, 296, 153) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 左＿左
  ctx.moveTo(248, 223) // 上
  ctx.quadraticCurveTo(288, 271, 317, 344) // 下
  // 左＿右
  ctx.moveTo(269, 190) // 上
  ctx.quadraticCurveTo(308, 261, 328, 322) // 下
  // 右＿左
  ctx.moveTo(300, 153) // 上
  ctx.quadraticCurveTo(316, 258, 332, 313) // 下
  // 右＿右
  ctx.moveTo(327, 128) // 上
  ctx.quadraticCurveTo(334, 236, 347, 292) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#282828'
}

const crossLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  // 左上＿右下
  ctx.strokeStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(310 + x, 304 + y) // 左＿上
  ctx.quadraticCurveTo(307 + x, 307 + y, 313 + x, 311 + y) // 左＿下
  ctx.quadraticCurveTo(338 + x, 305 + y, 338 + x, 305 + y) // 右＿下
  ctx.quadraticCurveTo(338 + x, 300 + y, 333 + x, 298 + y) // 右＿上
  ctx.quadraticCurveTo(322 + x, 296 + y, 310 + x, 304 + y) // 左＿上
  ctx.fill()
  ctx.moveTo(313 + x, 309 + y) // 左＿上
  ctx.quadraticCurveTo(325 + x, 304 + y, 338 + x, 304 + y) // 左＿下
  ctx.stroke()
  ctx.closePath()
  // 左下＿右上
  ctx.beginPath()
  ctx.moveTo(316 + x, 320 + y) // 左＿上
  ctx.quadraticCurveTo(315 + x, 326 + y, 320 + x, 330 + y) // 左＿下
  ctx.quadraticCurveTo(325 + x, 311 + y, 335 + x, 293 + y) // 右＿下
  ctx.quadraticCurveTo(335 + x, 285 + y, 331 + x, 284 + y) // 右＿上
  ctx.quadraticCurveTo(319 + x, 303 + y, 316 + x, 320 + y) // 左＿上
  ctx.fill()
  ctx.moveTo(319 + x, 327 + y) // 左＿上
  ctx.quadraticCurveTo(324 + x, 306 + y, 334 + x, 290 + y) // 左＿下
  ctx.stroke()
  ctx.closePath()
}
